import Vue from 'vue';

export default Vue.mixin({
    methods: {
        buildFilterParameters
    }
});

function buildFilterParameters(filter) {
    var parameters = {};

    if (typeof filter !== 'undefined' && filter !== null) {
        Object.keys(filter).forEach(key => parameters['filter.' + key] = filter[key]);
    }

    return parameters;
}
